module.exports = __webpack_public_path__ + "static/banner-small-0e64a3824301de9e1ba38e05030f227a.jpg";